import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetTempoMedioTotal } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, larguraColuna, eixoDias, formatarHoras, formatarMinutos, tooltipDias, useIndicador } from '../helpers'

export default function TempoMedioTotal({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetTempoMedioTotal, filters, (d) => !d.labels?.length)
  const dias = data?.labels || []

  const options = {
    chart: { type: 'line', stacked: false },
    colors: [CORES.laranja, CORES.primaria],
    stroke: { width: [0, 3], curve: 'smooth' },
    markers: { size: [0, 4] },
    plotOptions: { bar: { columnWidth: larguraColuna(dias.length), borderRadius: 3 } },
    xaxis: eixoDias(dias, 6),
    yaxis: [
      { seriesName: 'Média por usuário', min: 0, title: { text: 'Média' }, labels: { formatter: formatarHoras } },
      { seriesName: 'Tempo total', min: 0, opposite: true, title: { text: 'Total' }, labels: { formatter: formatarHoras } },
    ],
    legend: { position: 'top', horizontalAlign: 'right' },
    tooltip: { ...tooltipDias(dias), shared: true, intersect: false, y: { formatter: formatarMinutos } },
  }

  const series = [
    { name: 'Média por usuário', type: 'column', data: data?.media || [] },
    { name: 'Tempo total', type: 'line', data: data?.total || [] },
  ]

  return (
    <ChartCard title="Tempo assistido por dia" subtitle="Total do dia e média por usuário" status={status}>
      <ApexCharts options={options} series={series} type="line" height={280} />
    </ChartCard>
  )
}
